import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { fetchProfile, updateProfile } from "../lib/auth";
import { supabase } from "../lib/supabase";
import { BackIcon } from "../components/icons";

export default function EditProfileScreen() {
  const navigate = useNavigate();
  const [userId, setUserId] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [displayName, setDisplayName] = useState("");
  const [phone, setPhone] = useState("");

  const load = useCallback(async () => {
    try {
      const { data: auth } = await supabase.auth.getUser();
      if (!auth.user) return;
      setUserId(auth.user.id);
      const p = await fetchProfile(auth.user.id);
      if (p) {
        setDisplayName(p.display_name || "");
        setPhone(p.phone_number || "");
      }
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  async function handleSave() {
    if (!userId) return;
    setSaving(true);
    try {
      await updateProfile(userId, {
        display_name: displayName.trim(),
        phone_number: phone.trim() || null,
      });
      navigate(-1);
    } catch (err) {
      console.error(err);
      alert("Could not save profile.");
    } finally {
      setSaving(false);
    }
  }

  if (loading) return <div className="loading-screen">Loading…</div>;

  return (
    <div className="app-shell">
      <div className="header-row">
        <button type="button" className="icon-btn" onClick={() => navigate(-1)}>
          <BackIcon />
        </button>
        <h1 className="header-title">Edit Profile</h1>
        <div style={{ width: 40, height: 40 }} />
      </div>

      <div className="card" style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        <label className="section-label">DISPLAY NAME</label>
        <input
          className="text-input"
          value={displayName}
          onChange={(e) => setDisplayName(e.target.value)}
        />

        <label className="section-label">PHONE</label>
        <input
          className="text-input"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          type="tel"
          placeholder="+1 555 123 4567"
        />
      </div>

      <div className="sticky-cta-wrap">
        <button
          type="button"
          className="primary-btn"
          onClick={handleSave}
          disabled={saving}
        >
          {saving ? "Saving…" : "Save"}
        </button>
      </div>
    </div>
  );
}
